
import Vue from 'vue'
export default Vue.extend({
  props: {
    uploadingFiles: { type: Boolean, required: true },
    invalidFileUploaded: { type: Boolean, required: true }
  },
  computed: {
    fileRegex() {
      return /(image\/((gif)|(jpeg)|(png)|(tiff)|(svg\+xml)|(webp)))|(application\/pdf)/
    }
  },
  methods: {
    upload(event: Event) {
      if (this.uploadingFiles) {
        event.preventDefault()
        return
      }

      const target = event.target as HTMLInputElement
      const files = Array.from(target.files || [])
      const allValid = this.validateTypes(files.map(file => file.type))
      if (!allValid) {
        this.$emit('update:invalidFileUploaded', true)
      } else {
        this.uploadFiles(files)
      }
    },
    dropUpload(event: DragEvent) {
      event.preventDefault()
      this.$emit('update:invalidFileUploaded', false)
      if (this.uploadingFiles) {
        return
      }

      const items = event.dataTransfer?.items
      if (items && items.length) {
        const allValid = this.validateTypes(Array.from(items).map(item => item.getAsFile()?.type || null))
        if (!allValid) {
          this.$emit('update:invalidFileUploaded', true)
        } else {
          const files: File[] = []
          for (const item of items) {
            const file = item.getAsFile()
            if (file) {
              files.push(file)
            }
          }
          this.uploadFiles(files)
        }
      } else {
        const files = event.dataTransfer?.files || []
        const allValid = Array.from(files).every(file => this.fileRegex.test(file.type))

        if (!allValid) {
          this.$emit('update:invalidFileUploaded', true)
        } else {
          this.uploadFiles(Array.from(files))
        }
      }
    },
    validateTypes(types: (string | null)[]) {
      return types.every(type => this.fileRegex.test(type || ''))
    },
    dragOver(event: DragEvent) {
      event.preventDefault()
    },
    uploadFiles(files: File[]) {
      const chosenFiles = files.map(file => ({ name: file.name, status: 'none', file }))
      this.$emit('outFiles', chosenFiles)
    }
  }
})
